/** Способ создания черновика: подача декларации с целью получения вычета по расходам на благотворительность */
export const DRAFT_MODE = 7;

export const STEP_DEDUCTION = 'deductions';
export const STEP_DEDUCTION_FORM = `${STEP_DEDUCTION}Form`;
